/**
* Order participants
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider.state('order.confirmation', {
        url: '/' + urls.order.confirmation.fr + '/{order}/{mode}', // TODO : when multilang, change this to something dynamic
        resolve: {
            orderDefined: ['$q', '$stateParams', 'drupal', function ($q, $stateParams, $drupal) {
                console.log('order.confirmation: orderDefined', $stateParams.order);
                var deferred = $q.defer();

                $drupal.retrieveOrder($stateParams.order).then(function (result) {
                    deferred.resolve(result);
                }).catch(function (error) {
                    // if order is not accessible for user or does not exist
                    deferred.reject({ status: 'ORDER_CONFIRMATION__UNAUTHORIZED' });
                });

                return deferred.promise;
            }],
            deliveryDefined: ['$q', '$rootScope', function ($q, $rootScope) {
                var deferred = $q.defer();
                $rootScope.$watch('config.site.delivery_product.delivery_product_name', function (config) {
                    // we need nationality list and delivery product detection
                    if (config) {
                        deferred.resolve();
                    }
                });
                return deferred.promise;
            }],
        },
        views: {
            content: {
                controller: ['$scope', '$rootScope', 'profile', 'tools', '$filter', '$stateParams', 'orderDefined', 'cart', 'lodash', '$window', function ($scope, $rootScope, $profile, $tools, $filter, $stateParams, $orderDefined, $cart, lodash, $window) {
                    $scope.loading = false;
                    $scope.cartTemp = angular.copy($cart);
                    $cart.clear();

                    $scope.modePayment = $stateParams.mode;
                    $scope.config = $rootScope.config.site;

                    $scope.resultOrder = {
                        'products' : [],
                        'internships' : [],
                        'members' : 0,
                        'total_amount' : 0,
                        'membership_price': 0,
                        'deliveryPrice': 0,
                        'deliveryTime' : 0,
                        'quantity': 0
                    };
                    $scope.delivery = {};
                    $scope.profile = $profile.info;
                    $scope.closeDate = 0;
                    $scope.orderDefined = $orderDefined;

                    angular.forEach($orderDefined, function(element) {
                        if (element.type == 'product') {
                            $scope.resultOrder.total_amount += element.price * element.quantity;

                            if(element.name.toLowerCase().indexOf($scope.config.delivery_product.delivery_product_name.toLowerCase()) > -1) {
                                element.product_type = 'delivery';
                                $scope.closeDate = element.oportunity.CloseDate;
                                element.deliveryCountry = element.delivery.country;
                            }
                            if((element.specificType == 'Produit immatériel' || element.specificType == 'Produit de location') && element.startDate && element.endDate) {
                                element.product_type = 'internship_product';
                            }
                            var found = lodash.find($scope.resultOrder.products, { name: element.name, price: element.price });
                            if (found) {
                                found.quantity += 1;
                            } else {
                                $scope.resultOrder.products.push(element);
                            }
                        } else if (element.type == 'internship') {
                            $scope.resultOrder.total_amount += element.price * element.quantity;

                            var found = lodash.find($scope.resultOrder.products, { name: element.name, price: element.price});
                            if (found) {
                                found.quantity += 1;
                            } else {
                                $scope.resultOrder.products.push(element);
                            }

                        }/* else {
                            var found = lodash.find($scope.resultOrder.internships, { name: element.name, price: element.price});
                            if (found) {
                                found.quantity += 1;
                            } else {
                                $scope.resultOrder.internships.push(element);
                            }
                        } */
                    });

                    // retrieve internship product pricing from cart not from orderline (missing info)
                    // angular.forEach($scope.cartTemp.internships, function (element) {
                    //     console.log(element);
                    //     var price = element.field_internship.discount ? element.field_internship.discountPrice : element.field_internship.price;
                    //     $scope.resultOrder.total_amount += price * element.field_quantity;
                    //     var found = lodash.find($scope.resultOrder.internships, { name: element.name});
                    //     if (found) {
                    //         found.quantity += 1;
                    //     } else {
                    //         $scope.resultOrder.internships.push(element);
                    //     }
                    // });

                    // TODO delivery address?
                    if($orderDefined[0].delivery) {
                        $scope.delivery = $orderDefined[0].delivery;
                    } else{
                        $scope.delivery = {
                            address: $profile.info.field_adresse,
                            city: $profile.info.field_ville,
                            country: $profile.info.field_pays,
                            cp: $profile.info.field_cp
                        }
                    }

                    $scope.resultOrder.deliveryPrice =  $scope.cartTemp.deliveryPrice;
                    $scope.resultOrder.deliveryTime =  $scope.cartTemp.deliveryTime;
                    $scope.resultOrder.quantity =  $scope.cartTemp.quantity;
                    $scope.resultOrder.deliveryDate = new Date(new Date($scope.closeDate).getTime()+($scope.cartTemp.deliveryTime*24*60*60*1000));

                    // Send transaction info to ga
                    if ($scope.config.analytics && $scope.config.analytics.api && $window.ga) {
                        try {
                            $window.ga('ecommerce:addTransaction', {
                                'id': $stateParams.order,
                                'affiliation': 'Les Glénans',
                                'revenue': $scope.resultOrder.total_amount,
                                'shipping': $scope.resultOrder.deliveryPrice,
                                'tax': '0.00',
                                'currency': 'EUR'
                            });
                            $window.ga('ecommerce:send');
                        } catch(e) { console.error(e); }
                    }

                    // Matomo tracking
                    if ($window._paq) {
                        try {
                            // Add all products
                            var products = []
                            angular.forEach($orderDefined, function(element) {
                                products.push([
                                    element.sfid,
                                    element.name,
                                    element.type,
                                    element.price,
                                    element.quantity
                                ]);
                            });

                            // Group all product by sfid and sum quantity and price
                            var sfids = products.map(function (p) { return p[0]; }).filter(function (value, index, self) { return self.indexOf(value) === index; });
                            var uniqueProducts = sfids.map(function (sfid) {
                                var filtered = products.filter(function (p) { return p[0] === sfid; });
                                var price = filtered.reduce(function (a, b) { return a + (b[3] * b[4]); }, 0);
                                var quantity = filtered.reduce(function (a, b) { return a + b[4]; }, 0);
                                return [sfid, filtered[0][1], filtered[0][2], price, quantity];
                            });
                            uniqueProducts.forEach(function (product) {
                                $window._paq.push(['addEcommerceItem', product[0], product[1], product[2], product[3], product[4]]);
                            });
                            $window._paq.push(['trackEcommerceCartUpdate', this.field_total_amount]);
                            $window._paq.push(['trackEcommerceOrder',
                                $stateParams.order,
                                Number.parseFloat($scope.resultOrder.total_amount),
                                Number.parseFloat($scope.resultOrder.total_amount) - Number.parseFloat($scope.resultOrder.deliveryPrice),
                                0.0,
                                Number.parseFloat($scope.resultOrder.deliveryPrice),
                            ]);
                        } catch (e) { console.error(e); }
                    }

                    //TODO reservation case, get info from previous step ? + replace teaser body
                    $scope.panel_subtitle = $scope.config.cart_order.thanking_message;
                    $scope.teaserBody = $scope.config.cart_order.confirmation_message;
                    if( $scope.modePayment == 'booking'){
                        $scope.panel_subtitle = $scope.config.cart_reservation.thanking_message;
                        $scope.teaserBody = $scope.config.cart_reservation.confirmation_message;
                    }

                    $rootScope.titlePanel = {
                        title: $tools.replace($filter('translate')('order.confirmationThanks'), { name: $profile.info.field_prenom }),
                        subtitle: $scope.panel_subtitle
                    };

                    $rootScope.teaserPanel = {};
                    angular.merge($rootScope.teaserPanel, {
                        css: 'info',
                        body: $scope.teaserBody.value  });

                    $scope.prepare = {
                        title: 'Bien préparer mes stages',
                        body: '<p>Retrouvez les documents nécessaires à la préparation et au bon déroulement de votre stage pour profiter au mieux de cette aventure. Tous ces éléments vous ont été envoyé sur votre adresse e-mail et sont disponibles dans <a href="/mon-espace">votre espace</a>.</p> <table cellspacing="20"><tr><td align="center">' +
                            '<img src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ1NDU0NSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMzAgNGgyVjBoLTIiLz48cGF0aCBkPSJNNSAyaDI3VjBINSIvPjxwYXRoIGQ9Ik01IDM3aDJWMEg1Ii8+PHBhdGggZD0iTTUgMzdoNHYtMkg1TTEwLjQyMyAxMi44MDJsLS44NS0uNTNjLjA3LS4xMTIgMS43OC0yLjc3MiA3Ljc4Ny0yLjc3MiAzLjIyIDAgNC45MzYuNTE4IDYuNDUuOTc1IDEuMjczLjM4NCAyLjM3My43MTUgNC4xOC43MTUgMy44ODggMCA2LjIzNC0xLjU4NSA2LjI1Ny0xLjZsLjU3LjgyYy0uMTA0LjA3My0yLjYwNiAxLjc4LTYuODI4IDEuNzgtMS45NTUgMC0zLjE3NS0uMzY4LTQuNDY4LS43NTgtMS41Mi0uNDU4LTMuMDktLjkzMi02LjE2Mi0uOTMyLTUuMzkyIDAtNi45MjIgMi4yOC02LjkzNyAyLjMwMnpNMjEuOTg0IDI0LjhjLS40NzggMC0uODY0LS4zODYtLjg2NC0uODYzcy4zODYtLjg2NC44NjQtLjg2NGMuNDc3IDAgLjg2My4zODcuODYzLjg2NHMtLjM4Ni44NjMtLjg2My44NjN6bS0xLjIyNy0yLjA5bC0xLjUyIDMuOTczIDMuOTczLTEuNTIgMS41Mi0zLjk3Mi0zLjk3MyAxLjUyek0yMiAxOGMuNTUzIDAgMSAuNDQ4IDEgMXMtLjQ0NyAxLTEgMWMtLjU1MyAwLTEtLjQ0OC0xLTFzLjQ0Ny0xIDEtMU0yMiAyOGMuNTUzIDAgMSAuNDQ3IDEgMSAwIC41NTMtLjQ0NyAxLTEgMS0uNTUzIDAtMS0uNDQ3LTEtMSAwLS41NTMuNDQ3LTEgMS0xTTI3IDIzYy41NTMgMCAxIC40NDcgMSAxIDAgLjU1My0uNDQ3IDEtMSAxLS41NTMgMC0xLS40NDctMS0xIDAtLjU1My40NDctMSAxLTFNMTcgMjNjLjU1MyAwIDEgLjQ0NyAxIDEgMCAuNTUzLS40NDcgMS0xIDEtLjU1MyAwLTEtLjQ0Ny0xLTEgMC0uNTUzLjQ0Ny0xIDEtMSIvPjxwYXRoIGQ9Ik0yMiAxNWMtNC45NyAwLTkgNC4wMy05IDlzNC4wMyA5IDkgOSA5LTQuMDMgOS05LTQuMDMtOS05LTltMCAxYzQuNDEgMCA4IDMuNTkgOCA4cy0zLjU5IDgtOCA4LTgtMy41OS04LTggMy41OS04IDgtOCIvPjxwYXRoIGQ9Ik05IDM5aDI2VjRIOXYzNXptMi0xaDIyVjVIMTF2MzN6Ii8+PC9nPjwvc3ZnPg==" alt="" width="40" height="40"><br>Guide du stagiaire<br><strong>Adultes</strong><br><a href="https://dossier-presse.glenans.asso.fr/docs/Guide-stagiaire/guide-stagiaire-adulte.pdf">Télécharger</a></td><td align="center">' +
                            '<img src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ1NDU0NSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMzAgNGgyVjBoLTIiLz48cGF0aCBkPSJNNSAyaDI3VjBINSIvPjxwYXRoIGQ9Ik01IDM3aDJWMEg1Ii8+PHBhdGggZD0iTTUgMzdoNHYtMkg1TTEwLjQyMyAxMi44MDJsLS44NS0uNTNjLjA3LS4xMTIgMS43OC0yLjc3MiA3Ljc4Ny0yLjc3MiAzLjIyIDAgNC45MzYuNTE4IDYuNDUuOTc1IDEuMjczLjM4NCAyLjM3My43MTUgNC4xOC43MTUgMy44ODggMCA2LjIzNC0xLjU4NSA2LjI1Ny0xLjZsLjU3LjgyYy0uMTA0LjA3My0yLjYwNiAxLjc4LTYuODI4IDEuNzgtMS45NTUgMC0zLjE3NS0uMzY4LTQuNDY4LS43NTgtMS41Mi0uNDU4LTMuMDktLjkzMi02LjE2Mi0uOTMyLTUuMzkyIDAtNi45MjIgMi4yOC02LjkzNyAyLjMwMnpNMjEuOTg0IDI0LjhjLS40NzggMC0uODY0LS4zODYtLjg2NC0uODYzcy4zODYtLjg2NC44NjQtLjg2NGMuNDc3IDAgLjg2My4zODcuODYzLjg2NHMtLjM4Ni44NjMtLjg2My44NjN6bS0xLjIyNy0yLjA5bC0xLjUyIDMuOTczIDMuOTczLTEuNTIgMS41Mi0zLjk3Mi0zLjk3MyAxLjUyek0yMiAxOGMuNTUzIDAgMSAuNDQ4IDEgMXMtLjQ0NyAxLTEgMWMtLjU1MyAwLTEtLjQ0OC0xLTFzLjQ0Ny0xIDEtMU0yMiAyOGMuNTUzIDAgMSAuNDQ3IDEgMSAwIC41NTMtLjQ0NyAxLTEgMS0uNTUzIDAtMS0uNDQ3LTEtMSAwLS41NTMuNDQ3LTEgMS0xTTI3IDIzYy41NTMgMCAxIC40NDcgMSAxIDAgLjU1My0uNDQ3IDEtMSAxLS41NTMgMC0xLS40NDctMS0xIDAtLjU1My40NDctMSAxLTFNMTcgMjNjLjU1MyAwIDEgLjQ0NyAxIDEgMCAuNTUzLS40NDcgMS0xIDEtLjU1MyAwLTEtLjQ0Ny0xLTEgMC0uNTUzLjQ0Ny0xIDEtMSIvPjxwYXRoIGQ9Ik0yMiAxNWMtNC45NyAwLTkgNC4wMy05IDlzNC4wMyA5IDkgOSA5LTQuMDMgOS05LTQuMDMtOS05LTltMCAxYzQuNDEgMCA4IDMuNTkgOCA4cy0zLjU5IDgtOCA4LTgtMy41OS04LTggMy41OS04IDgtOCIvPjxwYXRoIGQ9Ik05IDM5aDI2VjRIOXYzNXptMi0xaDIyVjVIMTF2MzN6Ii8+PC9nPjwvc3ZnPg==" alt="" width="40" height="40"><br>Guide du stagiaire<br><strong>Juniors</strong><br><a href="https://dossier-presse.glenans.asso.fr/docs/Guide-stagiaire/guide-stagiaire-junior.pdf">Télécharger</a></td></tr>' +
                            '</table>'
                    };

                }],
                templateUrl: 'src/views/order/order_confirmation.html'
            }
        }
    });
}]);
